// Shared visual language for the ORBIT metaphor and scoring.

export const STATUS_META = {
  Strong: { label: "Strong", color: "hsl(160 84% 30%)", dot: "bg-emerald-600", text: "text-emerald-700 dark:text-emerald-400", ring: "ring-emerald-500/30" },
  Developing: { label: "Developing", color: "hsl(224 71% 45%)", dot: "bg-blue-600", text: "text-blue-700 dark:text-blue-400", ring: "ring-blue-500/30" },
  "At Risk": { label: "At Risk", color: "hsl(0 72% 48%)", dot: "bg-red-600", text: "text-red-700 dark:text-red-400", ring: "ring-red-500/30" },
  Opportunity: { label: "Opportunity", color: "hsl(32 95% 44%)", dot: "bg-amber-600", text: "text-amber-700 dark:text-amber-400", ring: "ring-amber-500/30" },
  Unknown: { label: "Unknown", color: "hsl(215 16% 55%)", dot: "bg-slate-400", text: "text-slate-600 dark:text-slate-400", ring: "ring-slate-500/30" },
};

export const LEVEL_META = {
  Nascent: { color: "hsl(0 72% 48%)", text: "text-red-600" },
  Foundational: { color: "hsl(32 95% 44%)", text: "text-amber-600" },
  Systematized: { color: "hsl(224 71% 45%)", text: "text-blue-600" },
  Optimized: { color: "hsl(160 84% 30%)", text: "text-emerald-600" },
  Autonomous: { color: "hsl(263 70% 55%)", text: "text-violet-600" },
  High: { color: "hsl(160 84% 30%)", text: "text-emerald-600" },
  Medium: { color: "hsl(32 95% 44%)", text: "text-amber-600" },
  Low: { color: "hsl(0 72% 48%)", text: "text-red-600" },
};

export const PRIORITY_META = {
  Immediate: { text: "text-red-700 dark:text-red-400", bg: "bg-red-500/10", border: "border-red-500/30" },
  "Quick Win": { text: "text-emerald-700 dark:text-emerald-400", bg: "bg-emerald-500/10", border: "border-emerald-500/30" },
  Strategic: { text: "text-blue-700 dark:text-blue-400", bg: "bg-blue-500/10", border: "border-blue-500/30" },
  Later: { text: "text-slate-600 dark:text-slate-400", bg: "bg-slate-500/10", border: "border-slate-500/30" },
};

export const QUADRANTS = {
  "quick-wins": { title: "Quick Wins", subtitle: "High impact · Low effort" },
  "strategic-bets": { title: "Strategic Bets", subtitle: "High impact · High effort" },
  "low-priority": { title: "Low Priority", subtitle: "Low impact · Low effort" },
  "complex-later": { title: "Complex / Later", subtitle: "Low impact · High effort" },
};

export function levelColor(level) {
  return (LEVEL_META[level] || LEVEL_META.Foundational).color;
}

export const SOURCE_LABELS = {
  responses: "Based on your responses",
  calculated: "Calculated",
  rule: "System rule",
  ai: "AI-generated insight",
  verify: "Requires verification",
};
